import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HttpHelperService {
  public checkIfRouteNotIsPublic(route: string): boolean {
    // Endpoints que aceitam token externo (HS256 Moderna) ou que NÃO devem
    // passar pelo refresh-token flow do AuthInterceptor. Um 401 nessas rotas
    // significa "token externo inválido", não "sessão Cognito expirada" — não
    // pode disparar refresh + retry (que faz loop infinito).
    if (/\/v1\/auth\/sso\/moderna(\?|$)/.test(route) || /\/v1\/auth\/sso\b/.test(route)) {
      return false;
    }

    const checkedRoute =
      !new RegExp('api-pabx').test(route) &&
      !new RegExp('ramais').test(route) &&
      (new RegExp('omnismart.app').test(route) ||
        new RegExp('twsolutions.com.br').test(route) ||
        new RegExp('omnismart.net').test(route) ||
        new RegExp('localhost').test(route));

    return !checkedRoute;
  }

  public isPabxRoute(route: string): boolean {
    return new RegExp('api-pabx').test(route) || new RegExp('ramais').test(route);
  }

  public setHttpParams(params: HttpParams, filters: any): HttpParams {
    Object.keys(filters).forEach((key) => {
      const filter = filters[key];
      if (filter !== null && filter !== '') {
        params = params.append(key, filter);
      }
    });
    return params;
  }
}
